import { Link } from "react-router-dom";
import { Newspaper, ArrowRight } from "lucide-react";

const ARTICOLI = [
  {
    id: "sempre-operativi",
    categoria: "Novità",
    data: "Giugno 2026",
    titolo: "ENPALSBOX è operativa anche nei weekend e nei giorni festivi",
    paragrafi: [
      "Le esibizioni non conoscono calendario: concerti, serate ed eventi si concentrano proprio nei fine settimana e nei periodi di festa. Per questo ENPALSBOX è sempre operativa: puoi inviare la richiesta di certificato di agibilità in qualsiasi momento, anche all'ultimo minuto.",
      "La pratica viene presa in carico senza attese legate a giorni lavorativi o orari d'ufficio: compili il modulo dalla tua Area Personale e ricevi la conferma via email con il numero di pratica.",
    ],
  },
  {
    id: "dati-da-preparare",
    categoria: "Guide",
    data: "Giugno 2026",
    titolo: "Certificato di agibilità: i dati da preparare prima della richiesta",
    paragrafi: [
      "Per inviare una richiesta completa e veloce ti consigliamo di avere a portata di mano: nome e indirizzo del locale (con città, provincia e C.A.P.), il tipo di attività svolta, la data dell'esibizione e l'importo pattuito per la prestazione.",
      "Il Codice Fiscale viene collegato automaticamente al tuo account: non devi reinserirlo a ogni richiesta. Dopo l'invio ricevi subito il numero di pratica univoco, utile per ogni comunicazione successiva.",
    ],
  },
  {
    id: "unilav-esenti",
    categoria: "Normativa",
    data: "Giugno 2026",
    titolo: "UniLAV: quando dipendenti e pensionati possono essere esenti",
    paragrafi: [
      "Chi svolge un'attività artistica occasionale ed è già lavoratore dipendente o pensionato può rientrare nei casi di esonero dagli adempimenti previdenziali ENPALS: in queste situazioni la prestazione può essere gestita tramite la comunicazione UniLAV.",
      "Se pensi di rientrare in questa casistica, scrivici a enpalsbox@enpalsbox.it prima di inviare la richiesta: ti indicheremo la strada corretta per la tua situazione specifica.",
    ],
  },
  {
    id: "dichiarazione-mensile",
    categoria: "Normativa",
    data: "Maggio 2026",
    titolo: "La dichiarazione mensile nello spettacolo: cos'è e perché è importante",
    paragrafi: [
      "La dichiarazione mensile è l'adempimento con cui vengono comunicate le prestazioni artistiche rese nel mese: è il passaggio che tiene allineata la tua posizione previdenziale con l'attività effettivamente svolta.",
      "Saltare o ritardare questo adempimento può creare problemi nella contribuzione collegata alle tue esibizioni. Nella pagina dedicata del sito trovi una spiegazione semplice, e per dubbi specifici puoi sempre contattarci.",
    ],
  },
  {
    id: "f24-contributi",
    categoria: "Adempimenti",
    data: "Maggio 2026",
    titolo: "Modello F24 e contributi: il collegamento con l'attività artistica",
    paragrafi: [
      "I compensi per le prestazioni artistiche danno luogo al versamento dei contributi previdenziali, che avviene tramite il modello F24: lo stesso modulo unificato usato per imposte e altri versamenti verso Stato ed enti previdenziali.",
      "Capire quando e come il modello F24 si collega alla tua attività ti evita sanzioni e ritardi. Trovi una guida semplice nella pagina F24 del sito; per la tua posizione specifica il nostro supporto è a disposizione.",
    ],
  },
];

export default function NewsPage() {
  return (
    <div className="mx-auto max-w-4xl px-4 py-16 sm:px-6 lg:px-8" data-testid="news-page">
      <div className="flex items-center gap-3">
        <span className="flex h-12 w-12 items-center justify-center rounded-lg bg-bordeaux text-white">
          <Newspaper className="h-6 w-6" />
        </span>
        <h1 className="section-title">News e aggiornamenti</h1>
      </div>
      <p className="mt-4 text-muted-foreground">
        Novità dal mondo ENPALSBOX, guide pratiche e aggiornamenti sugli adempimenti dello spettacolo.
      </p>

      <div className="mt-10 space-y-8">
        {ARTICOLI.map((a) => (
          <article key={a.id} className="card-elegant" data-testid={`news-article-${a.id}`}>
            <div className="flex flex-wrap items-center gap-2 text-xs font-semibold uppercase tracking-widest">
              <span className="rounded-full bg-bordeaux-ultralight px-3 py-1 text-bordeaux">{a.categoria}</span>
              <span className="text-muted-foreground">{a.data}</span>
            </div>
            <h2 className="mt-3 font-heading text-xl font-semibold text-bordeaux-dark sm:text-2xl">{a.titolo}</h2>
            <div className="mt-3 space-y-3 text-base leading-relaxed text-foreground/80">
              {a.paragrafi.map((p, i) => (
                <p key={i}>{p}</p>
              ))}
            </div>
          </article>
        ))}
      </div>

      <div className="mt-12 rounded-xl border border-bordeaux/20 bg-bordeaux-ultralight p-6 text-center sm:p-8" data-testid="news-cta">
        <p className="font-heading text-xl font-semibold text-bordeaux-dark">Hai un dubbio sulla tua situazione?</p>
        <p className="mt-2 text-sm text-muted-foreground">Il nostro team risponde a tutte le domande sugli adempimenti dello spettacolo.</p>
        <Link to="/contatti" data-testid="news-contact-button" className="btn-bordeaux mt-4">
          CONTATTACI <ArrowRight className="h-4 w-4" />
        </Link>
      </div>
    </div>
  );
}
